import { NgFor, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import groupArray from 'group-array';
import { getFormGroupFromModel } from '../../helpers/get-form-group-from-model.helper';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { ChecklisteModel } from './checkliste.model';

@Component({
  selector:      'gsm-checkliste',
  templateUrl:   './checkliste.component.html',
  styleUrls:     ['./checkliste.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone:    true,
  imports:       [
    NgFor,
    NgTemplateOutlet,
    FormsModule,
    ReactiveFormsModule,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
  ]
})
export class ChecklisteComponent extends CustomDynamicFormControlComponent<ChecklisteModel> implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);

  categoryMap: Record<string, string> = {};

  documentFormDataSource = [];
  tableFormArray: UntypedFormArray = this.formBuilder.array([]);
  dataSource: any = {};

  get dataSourceKeys() {
    return Object.keys(this.dataSource);
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    this.categoryMap = this.model.additional.checklistItemStatus;
    this.documentFormDataSource = this.model.value;
    this.updateDataSource();
  }

  getCategory(key: string) {
    return this.categoryMap[key];
  }

  updateDataSource() {
    this.tableFormArray.clear();
    this.documentFormDataSource.forEach((item, index) => {
      this.tableFormArray.push(getFormGroupFromModel(item, index));
    });
    this.dataSource = groupArray(this.tableFormArray.value, 'status');
  }
}
